/** True when the signed-in user must change their Cognito password. */
export function isForceResetRequired(auth) {
  return (
    auth?.user?.forceReset === true ||
    auth?.userAccess?.[0]?.forceReset === true
  );
}

export function getAuthIdentityId(auth) {
  return (
    auth?.user?.identityId ||
    auth?.userAccess?.[0]?.identityId ||
    null
  );
}
